/**
 * "Last used" badge shown next to the OAuth provider a returning user signed in
 * with last (resolved via authClient.getLastUsedLoginMethod). Shared by the
 * expert and researcher sign-in screens.
 */
export function LastUsedPill() {
  return (
    <span className="bg-card inline-flex items-center gap-1 rounded-[5px] border border-neutral-500 px-[5px] py-[2px] font-sans text-[10px] leading-[1.2] font-medium tracking-[-0.005em] text-neutral-500 dark:border-neutral-400 dark:text-neutral-400">
      Last used
    </span>
  );
}
